import "./GeneralDisplay.css"

export const NoDataToDisplay = () => {
    return (
        <div className="container noData">
            <p>
                No Data to Display
            </p>
        </div>
    )
}